import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { ProtectedRouteNoLayout } from "./ProtectedRouteNoLayout";
import Root from "./Root";
import Landing from "./pages/landing/Landing";
import About from "./pages/landing/about-us/About";
import Contact from "./pages/landing/contact/Contact";
import RequestDemo from "./pages/landing/request-demo/RequestDemo";
import BulkPayment from "./pages/landing/services/bulk-payment/BulkPayment";
import SupplierSettlment from "./pages/landing/services/SupplierSettlment";
import CashManagement from "./pages/landing/services/CashManagement";
import Airtime from "./pages/landing/services/Airtime";
import EventOrganizers from "./pages/landing/services/event-organizers/EventOrganizers";
import Contractors from "./pages/landing/services/contractors/Contractors";
import MSMEs from "./pages/landing/services/msmes/MSMEs";
import Enterprises from "./pages/landing/services/enterprises/Enterprises";
import Utility from "./pages/landing/utility/Utility";
import ElectricityPage from "./pages/landing/utility/electricity/ElectricityPage";
import WaterPage from "./pages/landing/utility/water/WaterPage";
import AirtimePage from "./pages/landing/utility/airtime/AirtimePage";
import Personal from "./pages/landing/personal/Personal";
import LandingLayout from "./pages/landing/LandingLayout";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        element: <LandingLayout />,
        children: [
          { path: "/", element: <Landing />, index: true },
          { path: "/landing", element: <Landing /> },
          { path: "/about", element: <About /> },
          { path: "/contact", element: <Contact /> },
          { path: "/request-demo", element: <RequestDemo /> },
          { path: "/services/bulk-payment", element: <BulkPayment /> },
          { path: "/services/bill-settlement", element: <SupplierSettlment /> },
          { path: "/services/petty-cash", element: <CashManagement /> },
          { path: "/services/airtime-data", element: <Airtime /> },
          { path: "/services/event-organizers", element: <EventOrganizers /> },
          { path: "/services/contractors", element: <Contractors /> },
          { path: "/services/msmes", element: <MSMEs /> },
          { path: "/services/enterprises", element: <Enterprises /> },
          { path: "/utility", element: <Utility /> },
          { path: "/utility/electricity", element: <ElectricityPage /> },
          { path: "/utility/water", element: <WaterPage /> },
          { path: "/utility/airtime", element: <AirtimePage /> },
          { path: "/personal", element: <Personal /> },
        ],
      },

      // Protected route WITHOUT sidebar/header for choose-screen
      {
        element: <ProtectedRouteNoLayout />,
        children: [],
      },
      // Protected routes WITH sidebar for all other authenticated pages
      {
        element: <ProtectedRoute role={"EXECUTIVE"} />,
        children: [],
      },
      {
        path: "*",
        element: <p>404 - Error: Page not found</p>,
      },
    ],
  },
]);
